const updateOptionsWithCSRF = (options) => {
  const update = { ...options };
  const meta = document.querySelector("meta[name=csrf-token]");
  const CSRFToken = meta && meta.content;

  if (CSRFToken) {
    update.headers = {
      ...update.headers,
      "X-CSRF-TOKEN": `${CSRFToken}`
    };
  }
  return update;
};

export const fetchWithCSRF = (url, options) => {
  return fetch(url, updateOptionsWithCSRF(options));
};

export const EVENT_STATUSES = {
  publish: "Publishing",
  published: "Live",
  pending: "Pending",
  reject: "Rejecting",
  rejected: "Rejected"
};

export const upperFirstOnly = (string) => {
  return string.charAt(0).toUpperCase() + string.toLowerCase().slice(1);
};

